
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BarChart3 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AIAnalysisCard: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('dashboard');

  const handleAnalysisClick = () => {
    navigate("/ai-analysis");
  };

  return (
    <Card className="bg-gradient-to-r from-green-50 to-green-100 border-green-200">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-green-800">
          <BarChart3 className="h-5 w-5" />
          {t('aiAnalysis.title')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <p className="text-green-700 text-sm mb-2">
              {t('aiAnalysis.description')}
            </p>
            <p className="text-green-600 text-xs">
              {t('aiAnalysis.features')}
            </p>
          </div>
          <Button 
            onClick={handleAnalysisClick}
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            {t('aiAnalysis.analyze')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default AIAnalysisCard;
